<div class="option" [ngClass]="{'selected': mode === PageContentMode.BASIC}"
     (click)="mode = PageContentMode.BASIC">
    <div class="option-label">
        {{basicLabel | translate}}
    </div>
</div>
<div *ngIf="customLabel1" class="option" [ngClass]="{'selected': mode === PageContentMode.CUSTOM1}"
     (click)="mode = PageContentMode.CUSTOM1">
    <div class="option-label">
        {{customLabel1 | translate}}
    </div>
</div>
<div *ngIf="customLabel2" class="option" [ngClass]="{'selected': mode === PageContentMode.CUSTOM2}"
     (click)="mode = PageContentMode.CUSTOM2">
    <div class="option-label">
        {{customLabel2 | translate}}
    </div>
</div>
<div *ngIf="customLabel3" class="option" [ngClass]="{'selected': mode === PageContentMode.CUSTOM3}"
     (click)="mode = PageContentMode.CUSTOM3">
    <div class="option-label">
        {{customLabel3 | translate}}
    </div>
</div>
<div class="option" [ngClass]="{'selected': mode === PageContentMode.DETAILED}"
     (click)="mode = PageContentMode.DETAILED">
    <div class="option-label">
        {{detailedLabel | translate}}
    </div>
</div>
